module.exports = __webpack_public_path__ + "static/media/TeamsAssets-Regular.76f7e592.ttf";